import { render, staticRenderFns } from "./scatter_update.md?vue&type=template&id=1e70d3ee&"
import script from "./scatter_update.md?vue&type=script&lang=js&"
export * from "./scatter_update.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e70d3ee')) {
      api.createRecord('1e70d3ee', component.options)
    } else {
      api.reload('1e70d3ee', component.options)
    }
    module.hot.accept("./scatter_update.md?vue&type=template&id=1e70d3ee&", function () {
      api.rerender('1e70d3ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/demo/scatter/scatter_update.md"
export default component.exports